<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('newTest' )}}

            <v-spacer/>

            <v-btn @click="$store.commit('setCreateTestDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                    <v-text-field v-model="getTest.title" :rules="titleRules" :label="$i18n.t('title')" :hint="$i18n.t('testTitleHint')" class="pa-0 ma-0"/>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            titleRules: [
                v => !!v || i18n.t('noTitle'),
                v => !v || v.length <= 200 || i18n.t('longTitle'),
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('createTest')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getCreateTestDialog',
            'getTest',
        ]),
    },

    watch: {
        getCreateTestDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>
